const getDefaultState = () => {
    return {
        sentInvitations: null,
        receivedInvitations: null
    }
}


const state = getDefaultState()

const getters = {
    getSentInvitations: (state) => state.sentInvitations,
    getReceivedInvitations: (state) => state.receivedInvitations,
};

const mutations = {
    resetInvitationsState: (state) => Object.assign(state, getDefaultState()),
    setSentInvitations: (state, sentInvitations) => state.sentInvitations = sentInvitations,
    setReceivedInvitations: (state, receivedInvitations) => state.receivedInvitations = receivedInvitations,
    removeReceivedInvite: (state, invitation) => {
        let index = state.receivedInvitations.indexOf(invitation);
        if (index > -1) {
            state.receivedInvitations.splice(index, 1);
        }
    }
};

const actions = {
    resetSentInvitations({commit}) {
        commit('setSentInvitations', []);
    },
    fetchSentInvitations: ({commit, getters}, forceApiCall = false) => {
        if (!getters.getSentInvitations || forceApiCall) {
            axios({
                  method: 'GET',
                  url: window.config.apiUrl + 'api/invitation/sent',
                cancelToken: window.AuthorizationCancelSource.token,
              }).then(response => {
                commit('setSentInvitations', response.data);
            });
        }
    },
    fetchReceivedInvitations: ({commit, getters}) => {
        if(!getters.getReceivedInvitations || true){
            axios({
                method: 'GET',
                url: window.config.apiUrl + 'api/invitations/received',
                cancelToken: window.AuthorizationCancelSource.token,
            }).then(response => {
                commit('setReceivedInvitations', response.data);
            });
        }
    },
    acceptInvite: ({commit, getters}, invitation) => {
        if(invitation){
            axios({
                method: 'POST',
                url: window.config.apiUrl + 'api/invitation/accept',
                cancelToken: window.AuthorizationCancelSource.token,
                data: {
                    hash: invitation.hash
                }
            }).then( () => {
                commit('removeReceivedInvite', invitation);
            });
        }
    },
    rejectInvite: ({commit, getters}, invitation) => {
        if(invitation){
            axios({
                method: 'POST',
                url: window.config.apiUrl + 'api/invitation/reject',
                cancelToken: window.AuthorizationCancelSource.token,
                data: {
                    hash: invitation.hash
                }
            }).then( () => {
                commit('removeReceivedInvite', invitation);
            });
        }
    },
    resetInvitationStates: ({commit}) => {
        commit('setReceivedInvitations', null);
        commit('setSentInvitations', null);
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
